import { ReactNode, useEffect, useMemo, useState } from "react";
import { useLoadedData } from "../../../toolympus/hooks/useLoadedData";
import { useSpace } from "../../Spaces/SpaceContext";
import { useThrottledCapture } from "../../../toolympus/components/primitives";
import { useHistory } from "react-router-dom";

interface ProjectSearchResultItem {
  project_id: string;
  title: string;
}

interface KnowledgeBaseSearchResultItem {
  _id: string;
  title: string;
}

interface SearchResultsData {
  projects: ProjectSearchResultItem[];
  knowledge_base: KnowledgeBaseSearchResultItem[];
}

export interface SearchTarget {
  title: ReactNode;
  kind: ReactNode;
  url: string;
}

const PredefinedSearchResults = [
  {
    title: "Проекты",
    kind: "Страница",
    url: "/projects",
    searchKey: "проекты projects",
  },
  {
    title: "Страницы",
    kind: "Страница",
    url: "/kb",
    searchKey: "страницы pages база знаний knowledge base",
  },
]

export const useSearchPalette = () => {
  const { spaceId } = useSpace();
  const [search, setSearch] = useState<string>("");
  const searchApplied = useThrottledCapture<string>(search, 500);
  const searchResultsData = useLoadedData<SearchResultsData>(`/api/s/${spaceId}/search?search=${searchApplied.trim()}`, { projects: [], knowledge_base: []}, !!spaceId && !!searchApplied.trim());

  const history = useHistory();

  const searchResults: SearchTarget[] = useMemo(() => {
    if(searchApplied.trim().length) {
      const fromPredefined = PredefinedSearchResults.filter(item => item.searchKey.includes(searchApplied.toLowerCase()));
      return [
        ...fromPredefined,
        ...searchResultsData.data.projects.map(p => ({ title: p.title, kind: "Проект", url: `/projects/${p.project_id}` })),
        ...searchResultsData.data.knowledge_base.map(d => ({ title: d.title, kind: "Страница", url: `/kb/${d._id}` })),

      ]
    } else {
      return PredefinedSearchResults;
    }
  }, [searchApplied, searchResultsData.data]);

  const [activeTargetIndex, setActiveTargetIndex] = useState<number>(0);
  const activeTarget = searchResults[activeTargetIndex];

  useEffect(() => {
      setActiveTargetIndex(0);
  }, [searchApplied]);


  const invokeTarget = (r: SearchTarget) => {
    history.push(r.url);
  }

  return {
    search,
    setSearch,
    searchResults,
    
    activeTarget,
    activeTargetIndex,

    invokeTarget,
    nextTarget: () => setActiveTargetIndex(x => x + 1 >= searchResults.length ? 0 : x + 1),
    prevTarget: () => setActiveTargetIndex(x => x - 1 < 0 ? Math.max(0, searchResults.length - 1) : x - 1),

    invokeActiveTarget: () => invokeTarget(activeTarget),
  }
  
}

export type SearchPaletteData = ReturnType<typeof useSearchPalette>;
